module.exports = __webpack_public_path__ + "assets/exception-delete.6ac54d7b.svg";